import cn from "classnames";
import styles from "./index.module.scss";

/**
 * Overlapping source icons for Verified Reserves (decorative; max 5 desktop / 3 mobile via CSS).
 */
export default function PortfolioReservesSourceStack({ sources }) {
  if (!sources?.length) {
    return null;
  }

  const orderedSources = [...sources].reverse();
  const mobileVisibleFromIndex = Math.max(0, orderedSources.length - 3);

  return (
    <div className={styles.reservesSourceStack} aria-hidden="true">
      {orderedSources.map((source, index) => (
        <span
          key={source.id}
          className={cn(
            styles.reservesSourceIconWrap,
            index < mobileVisibleFromIndex && styles.reservesSourceIconWrapMobileHidden
          )}
          style={{ zIndex: index + 1 }}
        >
          <img className={styles.reservesSourceIcon} src={source.icon} alt="" />
        </span>
      ))}
    </div>
  );
}
